
const styles = (theme) => ({
  headerIconStyles: {
    padding: "10px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: "pointer",
  },
  toggleAnimationButton: {
    float: "left",
    cursor: "pointer",
    padding: "3px 0px",
    display: "flex",
    alignItems: "center",
  },
  toggleAnimationButtonDispatchMap: {
    float: "left",
    cursor: "pointer",
    padding: "3px 8px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
  toggleAnimationButtonMenu: {
    justifyContent: "space-between",
  },
  headerButtonContainer: {
    padding: "6px 10px",
  },
  iconLayout: {
    float: "left",
    color: theme.iconColor,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
  search: {
    position: "relative",
    marginRight: 10,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.searchBGColor,
    "&:hover": {
      backgroundColor: theme.searchHoverBGColor,
    },
    marginLeft: 0,
    marginTop: 2,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit,
      width: "auto",
    },
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  transparentBG: {
    backgroundColor: 'transparent',
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
    height: 30,
    fontSize: theme.headerTextFontSize,
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 8,
    transitionDelay: "0.1s",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 60,
      "&:focus": {
        width: 160,
      },
    },
  },

  "@keyframes activateSavebtn": {
    "0%": {
      transform: "scale(1.0)",
    },
    "50%": {
      transform: "scale(1.4)",
    },
    "100%": {
      transform: "scale(1.0)",
    },
  },
  saveIconEnabled: {
    cursor: "pointer",
    color: theme.HeaderSelectedText,
    "& svg": {
      animation: "activateSavebtn 2s ease-in-out 0s infinite forwards",
    },
  },
  saveIconDisabled: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  showHeader: {
    display: "block",
  },
  hideHeader: {
    display: "none",
  },
  editControls: {
    "&>div": {
      float: "left",
    },
  },
  showEditMode: {
    "&>div:before,&>div:after": {
      content: "none",
    },
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  tspEnabledIcon: {
    color: theme.HeaderSelectedText,
  },
  fieldRoot: {
    color: theme.TextColor,
    borderBottom: `1px solid ${theme.iconColor}`,
    lineHeight: "normal",
  },
  iconStyle: {
    cursor: "pointer",
    color: theme.iconColor,
  },
  button: {
    minHeight: 24,
    fontSize: theme.textFontSize,
    padding: 0,
    textTransform: "none",
    "&$buttonDisabled": {
      borderColor: theme.HeaderSelectedText,
      cursor: "not-allowed",
    },
  },
  buttonDisabled: {},
  paperStyle: {
    backgroundColor: theme.ModalBGColor,
    marginTop: "40px",
  },
  menuItem: {
    paddingTop: "5px",
    paddingBottom: "5px",
    color: theme.TextColor,
    fontSize: theme.textFontSize,
  },
  selectedColorText: {
    color: theme.HeaderSelectedText,
  },
  inputStyle: {
    maxWidth: "100%",
    marginRight: 10,
  },
  reactSelect: {
    marginRight: 10,
    "& .select__control": {
      minWidth: 100,
      backgroundColor: "transparent",
      minHeight: 24,
      maxHeight: 24,
      boxSizing: "border-box",
      marginTop: 6,
      borderRadius: 2,
      border: `1px solid ${theme.iconColor}`,
      fontSize: theme.textFontSize,
      cursor: "pointer",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: `1px solid ${theme.iconColor}`,
      },
      "& .select__value-container": {
        height: 24,
        color: theme.TextColor,
      },
      "& .select__single-value": {
        color: "inherit",
      },
      "& .select__indicators": {
        height: 24,
        "& .select__indicator": {
          padding: 5,
          height: 24,
        },
        "& .select__indicator-separator": {
          height: 24,
          margin: 0,
          display: "none",
        },
      },
    },
    "& .select__menu": {
      margin: 0,
      maxHeight: 140,
      border: `1px solid ${theme.iconColor}`,
      borderRadius: "0 0 2px 2px",
      borderTop: "none",
      "& .select__menu-list": {
        maxHeight: 139,
        borderRadius: 2,
        fontSize: theme.textFontSize,
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor,
      },
      "& .select__option--is-focused": {
        backgroundColor: theme.HighlightColor,
        cursor: "pointer",
      },
      "& .select__option--is-selected": {
        backgroundColor: theme.HeaderSelectedText,
      },
    },
  },
  fieldValue: {
    height: 30,
    fontSize: theme.textFontSize,
    maxWidth: 100,
    "&$inputUnderline": {
      "&:before, &:after, &:hover:before": {
        borderColor: theme.iconColor,
      },
    },
  },
  inputUnderline: {},
  fieldInput: {
    fontSize: theme.textFontSize,
    "&::placeholder": {
      color: theme.iconColor,
    },
  },
  actionIcon: {
    fontSize: theme.headerTextFontSize,
  },
  updateMessage: {
    float: "left",
    lineHeight: "30px",
    fontSize: theme.headerTextFontSize,
    color: theme.HeaderSelectedText,
    paddingRight: "10px",
  },
  toggleText: {
    display: "inline-block",
    fontSize: theme.textFontSize,
    color: theme.iconColor,
  },
  showControl: {
    display: "block",
    float: "left",
  },
  hideControl: {
    display: "none",
  },
  clearIcon: {
    paddingRight: "5px",
  },
  iconHidden: {
    visibility: "hidden",
  },
  iconVisible: {
    visibility: "visible",
    color: theme.iconColor,
    cursor: "pointer",
    paddingRight: "5px",
  },
  activeIcon: {
    color: theme.HeaderSelectedText,
  },
  enabledDangerIcon:{
    color: theme.ErrorMessageColor
  },
  menuContainer: {
    width: "122px",
    backgroundColor: theme.ModalBGColor
  },
  messageContainer: {
    display: "flex"
  },
  menuLabel: {
    justifyContent: "flex-start",
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    cursor: "pointer",
    padding: "6 6 6 12",
    borderRadius: 0,
    "&:hover": {
      backgroundColor: theme.customMultiSelectColor,
    },
    width: "100%"
  },
  customPopper: {
    zIndex: 999,
    marginTop: 4
  },
  iconWithLabel: {
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    width : "100%"
  },
  iconLabel: {
    fontSize: theme.headerTextFontSize
  },
});

export default styles;
